<div>
  <rk-radio-sidebar-header
    (toggleSideNav)="toggleSideNav.emit()"
  ></rk-radio-sidebar-header>

  <rk-radio-sidebar-main></rk-radio-sidebar-main>
</div>
